module.exports = __webpack_public_path__ + "static/media/humanLaptopLight.53ffd737.svg";